// extracted by mini-css-extract-plugin
export default {"mainContainer":"mainContainer___taVQV","wasteAccompanyingDocumentContainer":"wasteAccompanyingDocumentContainer___d8vh4"};